import { FAGroupViewModel, MarkupNew } from '@fora-monorepo/employer-my-pages-common/types';
import { isAfter, isSameOrAfter, isSameOrBefore } from '@fora-monorepo/date-utils';

import { addOneDay } from '../../../employments/utils/addOneDay';
import { typedT } from '../../../i18n/i18n';

export const validateMarkupList = (
  list: MarkupNew[],
  employmentPeriodStartDate: string,
  employmentPeriodEndDate: string,
  faGroups: FAGroupViewModel[]
) => {
  const startDates = list.map(markup => markup.startDate);
  const errorMessages: string[] = [];

  // Must be at least one markup
  if (list.length === 0) {
    errorMessages.push(typedT('errorMessages.validation.markup.oneisrequired'));
    return errorMessages;
  }

  // * No start dates should be the same
  const duplicateStartDates = startDates.filter((date, index) => startDates.indexOf(date) !== index);
  if (duplicateStartDates.length > 0) {
    errorMessages.push(typedT('errorMessages.validation.markup.startsameday'));
  }

  list.forEach((eachMarkup, index) => {
    const isExpiring = faGroups.find(m => m.faGroupId === eachMarkup.faGroupId)?.validTo;

    // * No markup should start before the employment period starts
    if (!isSameOrAfter(eachMarkup.startDate, employmentPeriodStartDate)) {
      errorMessages.push(typedT('errorMessages.validation.markup.', { fokCode: eachMarkup.fokId }));
    }

    // * No markup should start after the employment period ends
    if (employmentPeriodEndDate && !isSameOrBefore(eachMarkup.startDate, employmentPeriodEndDate)) {
      errorMessages.push(typedT('errorMessages.validation.markup.starttolate', { fokCode: eachMarkup.fokId }));
    }

    // If isExpiring is before end, another markup must start the day after isExpiring or before.
    if (isExpiring && isAfter(employmentPeriodEndDate, isExpiring)) {
      const dayAfterIsExpiring = addOneDay(isExpiring);
      if (
        !list.find(
          (m, idx) =>
            idx !== index &&
            isAfter(m.startDate, eachMarkup.startDate) &&
            isSameOrBefore(m.startDate, dayAfterIsExpiring)
        )
      ) {
        errorMessages.push(
          typedT('errorMessages.validation.markup.gap', { fokCode: eachMarkup.fokId, fokIsExpiring: isExpiring })
        );
      }
    }
  });
  return errorMessages;
};
